import { render } from "./index.vue?vue&type=template&id=33328afe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/modal-header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33328afe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33328afe', __exports__)) {
    api.reload('33328afe', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=33328afe", () => {
    api.rerender('33328afe', render)
  })

}


export default __exports__